<template>

    <div class="l-public">
        <the-public-content class="l-public__content">
            <slot></slot>
        </the-public-content>
        <the-public-footer></the-public-footer>
    </div>

</template>


<script>

import ThePublicContent from 'Components/Public/ThePublicContent'
import ThePublicFooter from 'Components/Public/ThePublicFooter'

export default {

    name: 'LayoutPublic',

    created() {
        document.body.classList.remove('loading');
    },

    components: {
        ThePublicContent,
        ThePublicFooter
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.l-public {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;

    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-grow: 999;
        height: 100%;
    }
}

</style>
